import { helper } from '@ember/component/helper'

interface Signature {
  Args: {
    Positional: unknown[]
  }
  Return: boolean
}

export const endsWith = helper<Signature>(function ([fullString, comparison]) {
  if (typeof fullString === 'string' && typeof comparison === 'string') {
    return fullString.endsWith(comparison)
  }
  return false
})

export default endsWith
